import {
  ProgressCircularSize,
  ProgressCircularType,
} from "./progress-circular.type";

/**
 * Provides additional content for slh-progress-circular in error / success variants
 * @param {ProgressCircularSize} size
 * @param {ProgressCircularType} type
 */
export default function getIconContent(
  size: ProgressCircularSize,
  type: ProgressCircularType
): string {
  if (type === ProgressCircularType.PROGRESS) {
    return "";
  }
  switch (size) {
    case ProgressCircularSize.SM:
      if (type === ProgressCircularType.SUCCESS) {
        // from @slhuiadmin.icons.ico_passed
        return `<path class="icon" d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM11.003 16L18.073 8.929L16.659 7.515L11.003 13.172L8.174 10.343L6.76 11.757L11.003 16Z "/>`;
      }
      if (type === ProgressCircularType.ERROR) {
        // from @slhuiadmin.icons.ico_small_close
        return `<path class="icon" d="M11.9998 10.5861L9.17184 7.75708L7.75684 9.17208L10.5858 12.0001L7.75684 14.8281L9.17184 16.2431L11.9998 13.4141L14.8278 16.2431L16.2428 14.8281L13.4138 12.0001L16.2428 9.17208L14.8278 7.75708L11.9998 10.5861Z" />`;
      }
      return "";
    case ProgressCircularSize.MD:
      if (type === ProgressCircularType.SUCCESS) {
        // from @slhui.icons.ico_singselector, translated (4,4) pixels
        return `<path class="icon" d="M 14.0007 19.172 L 23.1927 9.979 L 24.6077 11.393 L 14.0007 22 L 7.6367 15.636 L 9.0507 14.222 L 14.0007 19.172 Z" />`;
      }
      if (type === ProgressCircularType.ERROR) {
        // from @slhui.icons.ico_close, translated (4,4) pixels
        return `<path class="icon" d="M 15.8006 14.5271 L 20.2556 10.0722 L 21.5282 11.3448 L 17.0732 15.7997 L 21.5282 20.2547 L 20.2556 21.5273 L 15.8006 17.0723 L 11.3456 21.5273 L 10.073 20.2547 L 14.528 15.7997 L 10.073 11.3448 L 11.3456 10.0722 L 15.8006 14.5271 Z" />`;
      }
      return "";
    case ProgressCircularSize.LG:
      if (type === ProgressCircularType.SUCCESS) {
        return `<path class="icon" d="M22.0002 27.172L31.1922 17.979L32.6072 19.393L22.0002 30L15.6362 23.636L17.0502 22.222L22.0002 27.172Z"/>`;
      }
      if (type === ProgressCircularType.ERROR) {
        return `<path class="icon" d="M23.9997 22.586L28.9497 17.636L30.3637 19.05L25.4137 24L30.3637 28.95L28.9497 30.364L23.9997 25.414L19.0497 30.364L17.6357 28.95L22.5857 24L17.6357 19.05L19.0497 17.636L23.9997 22.586Z"/>`;
      }
      return "";
    default:
      // eslint-disable-next-line no-console
      console.error("[slh-progress-circular] Invalid component size.");
      return "";
  }
}
